import { isNil } from 'ramda';

export const convertToNumber = (value) =>
  !isNil(value) ? Number(value) : value;
